var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading || _vm.serviceUnavailable)?_c(_vm.name,{key:("observability" + (_vm.$route.name) + _vm.loading),tag:"component",attrs:{"service-requested":_vm.serviceRequested,"name":"Observability"}}):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }